import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BigCTA } from '@/components/BigCTA';

export function SuccessPage() {
  const { id } = useParams<{ id: string }>();
  const nav = useNavigate();

  // ТЗ §3.2 экран 4: оптимистичный UI — анимация моментально, ошибки придут пушом.
  useEffect(() => {
    const t = setTimeout(() => nav('/', { replace: true }), 4500);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div className="page" style={{ alignItems: 'center', textAlign: 'center', minHeight: '80vh', justifyContent: 'center' }}>
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 220, damping: 14 }}
        style={{
          width: 120, height: 120, borderRadius: '50%',
          background: 'rgba(77, 196, 119, 0.18)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 64,
        }}
        aria-hidden
      >
        ✅
      </motion.div>

      <motion.div
        initial={{ y: 12, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.25 }}
      >
        <h1 className="page-title" style={{ margin: '8px 0' }}>Отлично!</h1>
        <p style={{ color: 'var(--bk-hint)', fontSize: 15, lineHeight: 1.4, maxWidth: 320 }}>
          Скриншоты улетели на проверку нейросетью.<br />
          Деньги поступят на баланс через 1–2 минуты.
        </p>
      </motion.div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%', maxWidth: 360 }}>
        {id && (
          <BigCTA variant="secondary" onClick={() => nav(`/submissions/${id}`)}>
            Посмотреть статус
          </BigCTA>
        )}
        <BigCTA onClick={() => nav('/', { replace: true })}>
          На главную
        </BigCTA>
      </div>
    </div>
  );
}
